<template>
	<div>

		<div class="form-group row">
			<label for="" class="col-lg-3 col-form-label">Tahun Produksi</label>
			<div class="col-lg-4">
				<select v-model="form.tahun_produksi" class="form-control form-control-grey" @change="validateRequired">
					<option v-for="year in yearOptions" :key="year.value" :value="year.value">{{ year.text }}</option>
				</select>
			</div>
		</div>

		<div class="form-group row">
			<label for="" class="col-lg-3 col-form-label">GPS</label>
			<div class="col-lg-4">
				<div class="form-check form-check-inline">
					<input type="radio" id="inputRadioGpsY" class="form-check-input"
						v-model="form.gps" value="Y">
					<label for="inputRadioGpsY" class="form-check-label">Yes</label>
				</div>
				<div class="form-check form-check-inline">
					<input type="radio" id="inputRadioGpsN" class="form-check-input"
						v-model="form.gps" value="N">
					<label for="inputRadioGpsN" class="form-check-label">No</label>
				</div>
			</div>
		</div>

		<div class="form-group row">
			<label for="" class="col-lg-3 col-form-label">Asuransi</label>
			<div class="col-lg-4">
				<div class="form-check form-check-inline">
					<input type="radio" id="inputRadioAsuransiY" class="form-check-input"
						v-model="form.asuransi" value="Y">
					<label for="inputRadioAsuransiY" class="form-check-label">Yes</label>
				</div>
				<div class="form-check form-check-inline">
					<input type="radio" id="inputRadioAsuransiN" class="form-check-input"
						v-model="form.asuransi" value="N">
					<label for="inputRadioAsuransiN" class="form-check-label">No</label>
				</div>
			</div>
		</div>

		<div class="form-group row">
			<label for="" class="col-lg-3 col-form-label">Tipe Truck</label>
			<div class="col-lg-4">
				<input
					type="text"
					v-model="form.type_truck"
					placeholder="Tipe Truck"
					class="form-control"
					@input="inputTypeTruck"
				/>
			</div>
		</div>

		<div class="form-group row">
			<label for="" class="col-lg-3 col-form-label">Tanggal Efektif</label>
			<div class="col-lg-4">
				<div class="input-group input-group-grey">
					<flat-pickr
						:config="configDatePicker"
						placeholder="Tanggal Mulai Efektif"
						v-model="form.tanggal_mulai_efektif"
						@change="validateRequired"
					></flat-pickr>
					<span class="input-group-text"><i class="far fa-calendar"></i></span>
				</div>
			</div>
		</div>

		<div class="form-group row">
			<label for="" class="col-lg-3 col-form-label">Tanggal Non Efektif</label>
			<div class="col-lg-4">
				<div class="input-group input-group-grey">
					<flat-pickr
						:config="configDatePicker2"
						placeholder="Tanggal Akhir Efektif"
						v-model="form.tanggal_akhir_efektif"
						@change="validateRequired"
					></flat-pickr>
					<span class="input-group-text"><i class="far fa-calendar"></i></span>
				</div>
			</div>
		</div>

		<div class="form-group row">
			<div class="col-lg-12">
				<div class="form-check form-check-inline">
					<input type="checkbox" id="inputCheckboxBantuan" class="form-check-input"
						v-model="form.truck_bantuan" value="1">
					<label for="inputCheckboxBantuan" class="form-check-label ms-5">Truck Bantuan</label>
				</div>
			</div>
		</div>

		<div class="d-flex justify-content-end">
			<button 
				type="button"
				class="btn btn-back"
				@click="prevPage">Kembali</button>
			<button 
				type="button"
				class="btn btn-submit"
				:disabled="!isAllStep2Required"
				@click="submitForm">Simpan Truck</button>
		</div>

	</div>
</template>

<style scoped>
.form-group.row {
	align-items: center;
}
</style>

<script>
import moment from 'moment'

export default {
    data() {
		return {
			isAllStep2Required: false,
			//
			configDatePicker: {
				dateFormat: "Y-m-d",
				altInput: true,
				altFormat: "d M Y",
				altInputClass: 'form-control form-flatpickr',
				defaultDate: moment().format("YYYY-MM-DD")
            },
			//
			configDatePicker2: {
				dateFormat: "Y-m-d",
				altInput: true,
				altFormat: "d M Y",
				altInputClass: 'form-control form-flatpickr',
				defaultDate: moment().format("YYYY-MM-DD")
            },
		};
	},
	components: {
		//
	},
	computed: {
		//
	},
	mounted () {
		//
	},
	props: ['form', 'yearOptions'],
	created() {
		//
	},
	watch: {
		//
	},
  	methods: {
		//
		inputTypeTruck() {
			this.form.type_truck = this.form.type_truck.toUpperCase();
			this.validateRequired();
		},
		validateRequired() {
			if (this.form.tahun_produksi && 
				this.form.type_truck && 
				this.form.tanggal_mulai_efektif && 
				this.form.tanggal_akhir_efektif) {
				this.isAllStep2Required = true
			} else {
				this.isAllStep2Required = false
			}
			// console.log(this.form)
		},	
 		prevPage() {
 			this.$emit('prevPage');
 		},
 		submitForm() {
 			this.$emit('submitForm');
 		},
  },
};
</script>